import { SpeciesEnum } from "requests";

export const SPECIES_OPTIONS = [
  { value: SpeciesEnum.Dog, label: "Dog (Canine)" },
  { value: SpeciesEnum.Cat, label: "Cat (Feline)" },
  { value: SpeciesEnum.Bird, label: "Bird (Avian)" },
  { value: SpeciesEnum.Ferret, label: "Ferret (Mustelid)" },
  { value: SpeciesEnum.Hamster, label: "Hamster (Rodent)" },
  { value: SpeciesEnum.GuineaPig, label: "Guinea Pig (Rodent)" },
  { value: SpeciesEnum.Mouse, label: "Mouse (Rodent)" },
  { value: SpeciesEnum.Rat, label: "Rat (Rodent)" },
  { value: SpeciesEnum.Rabbit, label: "Rabbit (Lagomorph)" },
  { value: SpeciesEnum.Reptile, label: "Reptile" },
  { value: SpeciesEnum.Rodent, label: "Rodent" },
  { value: SpeciesEnum.Amphibian, label: "Amphibian" },
  { value: SpeciesEnum.Tortoise, label: "Tortoise (Reptile)" },
  { value: SpeciesEnum.Turtle, label: "Turtle (Reptile)" },
  { value: SpeciesEnum.Fish, label: "Fish" },
  { value: SpeciesEnum.Chinchilla, label: "Chinchilla (Rodent)" },
  { value: SpeciesEnum.SugarGlider, label: "Sugar glider (Marsupial)" },
  { value: SpeciesEnum.Snake, label: "Snake (Reptile)" },
  { value: SpeciesEnum.Hedgehog, label: "Hedgehog" }
];
